import React from "react";

import { tr } from "../i18n";
export default function CTASection({ onIllustration }) {
  return (
    <section
      id="about"
      className="bg-[#0b1f3a] py-20 md:py-28 relative overflow-hidden scroll-mt-20"
    >
      <div className="pointer-events-none absolute -top-24 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full border border-[#c2a15a]/10" />
      <div className="pointer-events-none absolute top-8 left-1/2 -translate-x-1/2 w-[420px] h-[420px] rounded-full border border-[#c2a15a]/10" />
      <div className="max-w-4xl mx-auto px-5 md:px-8 text-center relative z-10">
        <div className="deco-line w-24 mx-auto mb-6" />
        <h2 className="font-display text-white text-[36px] md:text-[52px] leading-tight">
          {tr("Don't just hold it.")}{" "}
          <span className="text-[#c2a15a] italic">{tr("Grow it.")}</span>
        </h2>
        <p className="text-white/60 text-[17px] md:text-[19px] mt-5 max-w-2xl mx-auto">
          {tr("Join clients across the UK putting their cash to work — with the diversification, protection and returns they deserve.")}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-9">
          <button
            onClick={onIllustration}
            className="inline-flex items-center justify-center border border-white/25 hover:border-[#c2a15a] text-white hover:text-[#c2a15a] font-medium uppercase tracking-wide text-[14px] px-8 py-4 rounded-full transition-colors"
          >
            {tr("Request an illustration")}
          </button>
        </div>
      </div>
    </section>
  );
}
